/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Formate un lieu (adresse, lieu de naissance, lieu de dissolution, etc.)
 * affiché sur la fiche : `codePostal - LOCALITE (Pays)`, ou `fallback` si
 * localite et codePostal sont tous deux absents. Le pays n'est ajouté que
 * s'il est renseigné.
 */
const formatLieu = (
  localite?: string | null,
  codePostal?: string | null,
  libellePays?: string | null,
  fallback = 'Non renseigné',
): string => {
  const parts = [codePostal, localite?.toUpperCase()].filter(Boolean);

  if (parts.length === 0) {
    return fallback;
  }

  return `${parts.join(' - ')}${libellePays ? ` (${libellePays})` : ''}`;
};

export default formatLieu;
